import { DisciplineOutput } from '@/api/gql/graphql';
import { create } from 'zustand';
import { useEffect } from 'react';

type TopicsStore = {
  isOpenTopicModal: boolean;
  openTopicModal: () => void;

  selectedDiscipline: DisciplineOutput | null;
  setSelectedDiscipline: (discipline: DisciplineOutput) => void;
  initializeSelectedDiscipline: (disciplines: DisciplineOutput[]) => void;
};

export const useTopicsStore = create<TopicsStore>()((set, get) => ({
  isOpenTopicModal: false,
  openTopicModal: () =>
    set((state) => ({ isOpenTopicModal: !state.isOpenTopicModal })),

  selectedDiscipline: null,
  setSelectedDiscipline: (discipline) =>
    set({ selectedDiscipline: discipline }),

  initializeSelectedDiscipline: (disciplines) => {
    const { selectedDiscipline } = get();

    if (disciplines.length > 0) {
      set({ selectedDiscipline: disciplines[0] });

      if (selectedDiscipline) {
        const disciplineExists = disciplines.some(
          (d) => d._id === selectedDiscipline._id,
        );

        if (!disciplineExists) {
          set({ selectedDiscipline: disciplines[0] });
        }
      }
    }
  },
}));

export const useInitializeSelectedDiscipline = (
  disciplines: DisciplineOutput[] | undefined,
) => {
  const initializeSelectedDiscipline = useTopicsStore(
    (state) => state.initializeSelectedDiscipline,
  );

  useEffect(() => {
    if (disciplines && disciplines.length > 0) {
      initializeSelectedDiscipline(disciplines);
    }
  }, [disciplines, initializeSelectedDiscipline]);
};
